import "~assets/styles/global.css"
import "@fontsource-variable/inter"

function getLocalStorage() {
  try {
    // Because this throws in iframe in incognito mode
    return window.localStorage
  } catch {
    return undefined
  }
}

if (typeof window !== "undefined") {
  if (window.location.search.includes("fastly-devhub-editor") && getLocalStorage()) {
    getLocalStorage().setItem("fastly-devhub-editor", true)
  }

  window.initializePendo = function (apiKey) {
    ;(function (p, e, n, d, o) {
      var v, w, x, y, z
      o = p[d] = p[d] || {}
      o._q = o._q || []

      v = ["initialize", "identify", "updateOptions", "pageLoad", "track"]
      for (w = 0, x = v.length; w < x; ++w)
        (function (m) {
          o[m] =
            o[m] ||
            function () {
              o._q[m === v[0] ? "unshift" : "push"]([m].concat([].slice.call(arguments, 0)))
            }
        })(v[w])

      y = e.createElement(n)
      y.async = !0
      y.src = "https://cdn.pendo.io/agent/static/" + apiKey + "/pendo.js"

      z = e.getElementsByTagName(n)[0]
      z.parentNode.insertBefore(y, z)
    })(window, document, "script", "pendo")
  }

  if (process.env.GATSBY_PENDO_API_KEY) {
    window.initializePendo(process.env.GATSBY_PENDO_API_KEY)
    // eslint-disable-next-line no-undef
    pendo.initialize()
  }
}
